import { useEffect, useState } from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import { useAccessToken } from '../auth/use-access-token.js';
import { apiFetch, ApiError, NotSignedIn } from './client.js';

/**
 * The family's team assessment times (032; boards B1 and B2): the teams the
 * Home notice is for - none means no notice - and their open reserved hours.
 */
export interface AssessmentTimes {
  teams: { team_id: string; name: string }[];
  slots: { slot_id: string; slot_start: string; slot_end: string; facility_name: string; resource_name: string; team_ids: string[] }[];
}

export type AssessmentTimesState =
  | { status: 'loading' }
  | { status: 'ready'; times: AssessmentTimes }
  | { status: 'failed'; message: string };

export function useAssessmentTimes(): AssessmentTimesState {
  const isAuthenticated = useIsAuthenticated();
  const getToken = useAccessToken();
  const [state, setState] = useState<AssessmentTimesState>({ status: 'loading' });

  useEffect(() => {
    if (!isAuthenticated) return;
    let cancelled = false;
    apiFetch<AssessmentTimes>('/api/assessment-times', getToken)
      .then((times) => {
        if (!cancelled) setState({ status: 'ready', times });
      })
      .catch((cause: unknown) => {
        if (cancelled || cause instanceof NotSignedIn) return;
        setState({ status: 'failed', message: cause instanceof ApiError ? cause.message : 'That did not load' });
      });
    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, getToken]);

  return state;
}
